import { CommonModule, NgFor } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Column } from '../../../models/column';
@Component({
  selector: 'app-show-hide-columns',
  standalone: true,
  imports: [CommonModule, FormsModule, NgFor, TranslateModule],
  templateUrl: './show-hide-columns.component.html',
  styleUrl: './show-hide-columns.component.scss',
})
export class ShowHideColumnsComponent implements OnInit {
  @Input() selectedColumns: Column[] = [];
  @Input() columns: Column[] = [];
  @Output() columnsChange: EventEmitter<Column[]> = new EventEmitter();

  showInput = false;
  columnsList: Column[] = [];
  filteredColumns: Column[] = [];
  isShowHideOpen = false;
  searchText = '';
  originalColumns: Column[] = [];

  constructor(private toastr: ToastrService) {}

  ngOnInit(): void {
    this.filteredColumns = this.columns;
    this.originalColumns = [...this.columns]; //original order
  }

  toggleModal() {
    this.isShowHideOpen = !this.isShowHideOpen;
  }

  toggleSearch() {
    this.showInput = !this.showInput;
    if (!this.showInput) {
      this.searchText = '';
    }
  }

  onKeyUp(event: KeyboardEvent): void {
    this.filterColumns();
  }

  filterColumns(): void {
    const searchTextLower = this.searchText.toLowerCase();
    this.filteredColumns = this.columns.filter((column) =>
      column.header.toLowerCase().includes(searchTextLower),
    );
  }

  isSelected(column: Column): boolean {
    return this.selectedColumns.some(
      (selectedColumn) => selectedColumn.key === column.key,
    );
  }

  onColumnChange(column: Column, event: Event): void {
  const isSelected = this.isSelected(column);

  if (isSelected) {
    // try remove
    if (this.selectedColumns.length <= 5) {
      this.toastr.warning('Minimal number of columns is 5.');
      return;
    }
    this.selectedColumns = this.selectedColumns.filter(
      (col) => col.key !== column.key
    );
  } else {
    // try add
    if (this.selectedColumns.length >= 14) {
      this.toastr.warning('Maximal number of columns is 14.');
      return;
    }
    this.selectedColumns.push(column);
  }

  // edit selected columns
  this.columnsChange.emit(this.selectedColumns);
  this.columnsList = this.selectedColumns;
}
}
